import { ObservableMap } from '@stencil/store';
import { handleLanguageChange } from '@uipath/portal-shell-util';

import { State } from '../types/state';

export function setLocaleSideEffect(store: ObservableMap<State>) {
    handleLanguageChange(language => {
        if (language !== store.get('locale')) {
            store.set('locale', language);
        }
    });
}
